import React from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';

import Spacing from '@marvelapp/marvel-ui/spacing';
import Heading from '@marvelapp/marvel-ui/heading';
import Paragraph from '@marvelapp/marvel-ui/paragraph';
import MarvelLink from '@marvelapp/marvel-ui/link';

import {
  getCnameForUrl,
  getNextRedirectParam,
  getUrlWithRedirect,
} from 'marketing-website/utils/forms';
import Page from 'marketing-website/components/modules/Page';
import AccountPagesWrap from 'marketing-website/components/modules/AccountPagesWrap';
import SSOForm from 'marketing-website/components/modules/SSOForm';
import { SIGNIN } from 'marketing-website/constants/urls';

export default function SSO({ history }) {
  const pageProps = {
    title: 'SSO | Marvel',
    meta: [
      {
        name: 'description',
        content:
          'Sign in to your secure Marvel SSO account and access all of our great features.',
      },
      { name: 'keywords', content: '' },
    ],
    header: false,
  };

  const cname = getCnameForUrl();
  const redirectTo = getNextRedirectParam();
  const signinLinkWithRedirect = getUrlWithRedirect(SIGNIN);

  let messaging = {
    header: (
      <Spacing type="margin" size="m" position="bottom">
        <Heading tag="h1" size="xxxl" weight="bold">
          Enterprise Platform SSO sign in
        </Heading>
      </Spacing>
    ),
    copy: (
      <Spacing type="margin" size="l" position="bottom">
        <Paragraph size="l" color="slate">
          If you don’t know your company name, speak to your account admin.
        </Paragraph>
      </Spacing>
    ),
  };

  if (cname) {
    messaging = {
      header: (
        <Spacing type="margin" size="xs" position="bottom">
          <Heading tag="h1" size="xxxl" weight="bold">
            Enterprise Platform SSO sign in
          </Heading>
        </Spacing>
      ),
      copy: (
        <Spacing type="margin" sizeМ="m" position="bottom">
          <Paragraph size="l" color="slate">
            Click the button below to access Marvel using your Single Sign-On
            provider.
          </Paragraph>
        </Spacing>
      ),
    };
  }

  return (
    <Page {...pageProps}>
      <AccountPagesWrap history={history}>
        <SSOForm redirectTo={redirectTo} cname={cname} messaging={messaging} />
        <Spacing type="margin" size="m" sizeM="0" position="top">
          <Paragraph size="m" color="slate">
            Switch to standard{' '}
            <Link to={signinLinkWithRedirect}>
              <MarvelLink type="blue">sign in</MarvelLink>
            </Link>
          </Paragraph>
        </Spacing>
      </AccountPagesWrap>
    </Page>
  );
}

SSO.propTypes = {
  history: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/pages/sso/index.js